import produce from 'immer';
import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import { Map as ImmutableMap } from 'immutable';
const initialState = {
  openId: null,
  isActive: false,
  modalState: ImmutableMap()
};
export default ((state = initialState, action) => produce(state, newState => {
  switch (action.type) {
    case ActionTypes.MENU_BAR_SET_OPEN_ID:
      newState.openId = action.payload.openId;
      break;
    case ActionTypes.MENU_BAR_SET_IS_ACTIVE:
      newState.isActive = action.payload.isActive;
      break;
    case ActionTypes.MENU_BAR_SET_MODAL_STATE_BY_ID:
      newState.modalState = newState.modalState.set(action.payload.menuOptionId, action.payload.modalState);
      break;
    default:
  }
}));